export default class VoicesSwiper {
    constructor() {
        this.init();
    }

    init() {
        this.voicesSwiper();
    }

    voicesSwiper() {
        const swiper = new Swiper('.swiper', {
            loop: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 34,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}
